import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import LandingPage from '../components/LandingPage'
import MusicPlayer from '../components/MusicPlayer';

function Home() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <MusicPlayer />
      <LandingPage />
      <HeroSection />
      <Footer />
    </>
  );
}

export default Home;
